var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger",on:{"click":_vm.deleteData}},[_vm._t("default",function(){return [_c('i',{staticClass:"fas fa-trash"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }